import http from './_http'

const profile = {
  get: () => http.get(`api/v3/profile`),
  update: (m) => http.put(`api/v3/profile`, m),
}

export default profile